import { CalendarDots, Handshake, House, type Icon, MonitorPlay, Sparkle, Storefront } from '@/core/ui/icons';

export type NavPath = '/' | '/assistente' | '/visitas' | '/eventos' | '/cursos' | '/catalogo' | '/pedidos';

export interface NavEntry {
  to: NavPath;
  label: string;
  icon: Icon;
  exact?: boolean;
}

export interface NavGroup {
  label: string;
  items: NavEntry[];
}

/**
 * O menu, igual ao das abas do app: Catálogo de volta e a Centuria fora dele
 * (decisão de 21/10/2026). Ela segue no botão flutuante e na caixa "Fale com a
 * Centuria" do Início. Pedidos continua fora até ter o mínimo; a rota segue no
 * ar para quem tiver o link.
 */
export const NAV: NavGroup[] = [
  {
    label: 'Conteúdo',
    items: [
      { to: '/', label: 'Início', icon: House, exact: true },
      { to: '/cursos', label: 'Aulas', icon: MonitorPlay },
      { to: '/eventos', label: 'Eventos', icon: CalendarDots },
      { to: '/visitas', label: 'Visitas', icon: Handshake },
    ],
  },
  {
    label: 'Comercial',
    items: [{ to: '/catalogo', label: 'Catálogo', icon: Storefront }],
  },
];

/** Seções fora do menu que ainda dão título à barra superior. */
const UNLISTED: NavEntry[] = [{ to: '/assistente', label: 'Centuria', icon: Sparkle }];

/** O item de navegação a que uma URL pertence — dá o título da barra superior. */
export function navEntryFor(pathname: string): NavEntry | undefined {
  const entries = [...NAV.flatMap((g) => g.items), ...UNLISTED];
  return (
    entries.find((e) => e.exact && e.to === pathname) ??
    entries
      .filter((e) => !e.exact && (pathname === e.to || pathname.startsWith(`${e.to}/`)))
      .sort((a, b) => b.to.length - a.to.length)[0]
  );
}

/**
 * O mínimo que a Centuria sabe da tela quando a página não se descreve
 * (`usePageDescription`): a seção e o endereço.
 */
export function pageFallback(pathname: string): string {
  const section = navEntryFor(pathname);
  return section
    ? `Seção "${section.label}" do CentralOne (${pathname}).`
    : `Página ${pathname} do CentralOne.`;
}
